import React from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Search } from "@mui/icons-material";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import AreaForm from "../components/AreaForm";
import AreaTable from "../components/SlotCountTable";
import { useAreaMaster } from "../hooks/useAreaMaster";

const AreaMasterPage = () => {
  const {
    open,
    columns,
    loading,
    formValues,
    isDisabled,
    errorMessage,
    rows,
    handleClose,
    handleOpenForm,
    findDuplicateArea,
    handleInputChange,
    handleSearchChange,
  } = useAreaMaster();
  return (
    <>
      <Typography className="text-[#252F40] !mb-2">
        <Link to="/dashboard" className="no-underline">
          <span className="text-[#8C8C8C]">Masters / </span>
        </Link>
        Area
      </Typography>
      <Box
        sx={{
          boxShadow: " 0px 5px 15px -2px rgba(0, 0, 0, 0.12)",
          borderRadius: "2rem",
          width: "100%",
        }}
      >
        <Box className="flex justify-between px-3 py-2 items-center bg-[white]">
          <Box display="flex" p={1} alignItems="center">
            <TextField
              label="Search"
              onChange={handleSearchChange}
              size="small"
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Button
            variant="contained"
            onClick={handleOpenForm}
            className="!bg-[#3A416F] gap-2"
          >
            Add <AddBoxRoundedIcon />
          </Button>
          <AreaForm
            open={open}
            formValue={formValues}
            isDisabled={isDisabled}
            errorMessage={errorMessage}
            handleClose={handleClose}
            handleInputChange={handleInputChange}
            findDuplicateArea={findDuplicateArea}
          />
        </Box>
        <AreaTable columns={columns} loading={loading} rows={rows} />
      </Box>
    </>
  );
};

export default AreaMasterPage;
